<template>
  <div
    :class="{
      'form-group--error':
        typeof validate !== 'undefined' &&
        validate.$dirty &&
        !validate.$pending &&
        validate.$invalid,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div>
      <InputMask
        :id="id"
        :mask="mask"
        :slotChar="slotChar"
        :autoClear="autoClear"
        :unmask="unmask"
        :class="[
          {
            'p-invalid':
              typeof validate !== 'undefined' &&
              validate.$dirty &&
              !validate.$pending &&
              validate.$invalid,
          },
          inputClass,
          'form-control',
        ]"
        :readonly="readonly"
        :disabled="disabled"
        v-model="inputValue"
        :placeholder="placeholder"
      />
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>

<script>
import InputMask from "primevue/inputmask";

export default {
  inheritAttrs: false,
  components: {
    InputMask,
  },
  props: {
    mask: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    // Placeholder character in mask, default is underscore.
    slotChar: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    autoClear: {
      type: Boolean,
      default: false,
    },
    unmask: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      required: false,
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
